import React from 'react';

function Subtitle({ text }) {
  return <div className="text-xs md:text-sm tracking-tight">{text}</div>;
}

export default Subtitle;
